import * as React from "react";
import { SVGProps } from "react";
const SvgClose = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m22.703 21.187-5.288-5.204 5.208-5.283a.999.999 0 1 0-1.426-1.402l-5.208 5.283-5.288-5.204a1 1 0 0 0-1.403 1.424l5.287 5.205-5.208 5.283a1 1 0 1 0 1.425 1.402l5.21-5.284 5.286 5.205a1 1 0 0 0 1.493-1.327l-.088-.098Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgClose;
